import { Component, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { HttpClient } from '@angular/common/http'
import { throwError } from 'rxjs';

export interface PhotosApi {
  albumId?: number;
  id?: string;
  title?: string;
  url?: string;
  thumbnailUrl?: string;
}

@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss']
})
export class SliderComponent implements OnInit {

  apiData: PhotosApi[] = [];
  limit: number = 20; // <==== Edit this number to limit API results
  customOptions: OwlOptions = {
    items: 3,
    loop: true,
    autoplay: false,
    autoplaySpeed: 2000,
    autoplayTimeout: 10000,
    // center: true,
    dots: true,
    autoHeight: true,
    rtl: true,
    autoWidth: false,

    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 1,
      },
      1000: {
        items: 1,
      }
    }
  }

  constructor() { }

  ngOnInit() {
  }


}
